"use client"

import { useState } from "react"
import { Share2, Check, Copy } from "lucide-react"

interface ShareProfileButtonProps {
  url: string
  name: string
}

export default function ShareProfileButton({ url, name }: ShareProfileButtonProps) {
  const [copied, setCopied] = useState(false)

  const handleShare = async () => {
    // Try native share sheet first (works great on mobile)
    if (typeof navigator !== "undefined" && navigator.share) {
      try {
        await navigator.share({
          title: `${name} on Blue Collar Social`,
          url,
        })
        return
      } catch {
        // User dismissed — fall through to clipboard
      }
    }

    // Fallback: copy to clipboard
    try {
      await navigator.clipboard.writeText(url)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      // Last resort: prompt
      window.prompt("Copy your referral link:", url)
    }
  }

  return (
    <button
      onClick={handleShare}
      className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
    >
      {copied ? (
        <>
          <Check className="h-4 w-4 mr-2 text-green-600" />
          <span className="text-green-600">Copied!</span>
        </>
      ) : (
        <>
          <Share2 className="h-4 w-4 mr-2" />
          Share Profile
        </>
      )}
    </button>
  )
}
